export enum DriverStatus{
    OCCUPIED="OCCUPIED",
    NOTOCCUPIED="NOT OCCUPIED"
}